// consentManager.js
import { getCookie, setCookie, getLocalStorageItem, setLocalStorageItem } from "./cookieUtils";

const EU_COUNTRIES = [
  "AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "DE", "GR", "HU",
  "IE", "IT", "LV", "LT", "LU", "MT", "NL", "PL", "PT", "RO", "SK", "SI", "ES", "SE", 
  "NO", "IS", "LI", "GB", "CH"
];

export function isGDPRCountry() {
  const countryCode = (navigator.language || Intl.DateTimeFormat().resolvedOptions().locale)
    .split("-")
    .pop()
    .toUpperCase();
  return EU_COUNTRIES.includes(countryCode);
}

export function getGDPRConsent() {
  let consent = getCookie("euconsent-v2");
  if (consent) {
    try {
      return JSON.parse(atob(consent));
    } catch (error) {
      console.warn("[CMP] Failed to parse `euconsent-v2` cookie.");
    }
  }
  return getLocalStorageItem("userConsent", {});
}

export function storeGDPRConsent(consentData) {
  setLocalStorageItem("userConsent", consentData);
  setCookie("euconsent-v2", btoa(JSON.stringify(consentData)), 730);
}
